
// Basic
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
// Store & actions
import useMerchantAccountStore from '@/app/store/modules/merchantAccount';
import useRootOrganizationStore from '@/app/store/rootOrganization';
import actionsMerchantAccounts from '../../api/actionsMerchantAccounts';
// Components
import DataTable from '../../../../../common-utils/components/renders/dataTable/DataTable';
// Common
import { columnsMerchantAccount, columnsMerchantAccountId } from './columnDef/columnsMerchantAccounts';
import getInitialQuery from '@/common-utils/components/renders/dataTable/utils/getInitialQuery';
import mergeQuery from '@/common-utils/components/renders/dataTable/utils/mergeQuery';
import Permissions from '@/app/permissions/Permissions';
import CONTRACT_ACCESS from '../../api/apiUrls';
import MerchantAccountsImportProps from '../import/MerchantAccountsImportProps';
/**
* @param root0
* @param root0.pageActions
* @param root0.filtersEventName
* @returns {JSX} MerchantAccountsTable
 */
function MerchantAccountsTable({ pageActions = undefined, filtersEventName }) {
    // Store
    const rootOrganization = useRootOrganizationStore(s => s.rootOrganization);
    const { refetchMerchantAccounts: refetchFromStore, storeRefetchMerchantAccounts, query: queryStored, storeQuery } = useMerchantAccountStore();

    // Constants
    const initialQuery = getInitialQuery();

    // State
    const [query, setQuery] = useState(mergeQuery(initialQuery, queryStored));
    const [launchRefetch, setLaunchRefetch] = useState(true);

    // Api Calls
    const { data, isFetching, refetch } = actionsMerchantAccounts.getMerchantAccounts({ query: query, organizationId: rootOrganization.uuid }, false);

    useEffect(() => {
        if (rootOrganization && (launchRefetch || refetchFromStore)) {
            refetch();
            setLaunchRefetch(false);
            storeRefetchMerchantAccounts(false);
        }
    }, [query, launchRefetch, refetchFromStore]);

    const allColumns = columnsMerchantAccount({ query, setQuery, queryStored, storeQuery, setLaunchRefetch, filtersEventName });

    // Render
    return (
        <DataTable
            filtersEventName={filtersEventName}
            columns={allColumns}
            data={data}
            dataFetchingIsLoading={isFetching}
            columnsId={columnsMerchantAccountId}
            initialQuery={initialQuery}
            query={query}
            setQuery={setQuery}
            queryStored={queryStored}
            storeQuery={storeQuery}
            setLaunchRefetch={setLaunchRefetch}

            pageActions={pageActions}
            exportProps={{
                permissions: [Permissions.EXPORT_CONTRACTS_ACCESSES.name],
                api: CONTRACT_ACCESS.EXPORT_CONTRACTS_ACCESSES
            }}
            importProps={{
                ...MerchantAccountsImportProps,
                setLaunchRefetch,
                permissions: [Permissions.CSV_ADD_CONTRACTS_ACCESS.name]
            }}
        />
    );
}

MerchantAccountsTable.propTypes = {
    pageActions: PropTypes.node,
    filtersEventName: PropTypes.string
};

export default MerchantAccountsTable;